document.documentElement.classList.remove('no-js');

(function () {
  const theme = window.ShniffTheme || {};
  const status = () => document.getElementById('ThemeStatus');
  const announce = (message) => { if (status()) status().textContent = message; };
  const lockBody = () => document.body.classList.add('is-locked');
  const unlockBody = () => {
    if (!document.querySelector('.mobile-menu:not([hidden]), .cart-drawer:not([hidden]), .quick-buy-modal:not([hidden])')) document.body.classList.remove('is-locked');
  };

  let quickBuyReturnFocus;

  function updateQuickBuyVariant(modal) {
    const select = modal?.querySelector('[data-quick-buy-variant]');
    const option = select?.selectedOptions[0];
    if (!option) return;
    const variant = JSON.parse(option.dataset.variant);
    const idInput = modal.querySelector('[data-quick-buy-variant-id]');
    const quantity = modal.querySelector('[data-quick-buy-quantity]');
    const submit = modal.querySelector('[type="submit"]');
    const label = modal.querySelector('[data-add-label]');
    const current = modal.querySelector('[data-quick-buy-current]');
    const compare = modal.querySelector('[data-quick-buy-compare]');
    const savings = modal.querySelector('[data-quick-buy-savings]');
    const priceLabel = modal.querySelector('[data-quick-buy-price-label]');

    idInput.value = variant.id;
    quantity.min = String(variant.minimum || 1);
    quantity.step = String(variant.increment || 1);
    quantity.value = String(variant.minimum || 1);
    if (variant.maximum === null || variant.maximum === '') quantity.removeAttribute('max'); else quantity.max = String(variant.maximum);
    submit.disabled = !variant.available;
    label.textContent = variant.available ? 'Add to cart' : 'Sold out';
    current.textContent = formatMoney(variant.price);
    priceLabel.textContent = theme.customerIsPro ? 'Pro price' : '';

    if (variant.compareAtPrice > variant.price) {
      compare.hidden = false;
      compare.textContent = `${theme.customerIsPro ? 'MSRP ' : ''}${formatMoney(variant.compareAtPrice)}`;
      savings.hidden = false;
      savings.textContent = theme.customerIsPro ? `Save ${Math.round((variant.compareAtPrice - variant.price) * 100 / variant.compareAtPrice)}%` : 'Sale';
    } else {
      compare.hidden = true;
      savings.hidden = true;
    }
  }

  function openQuickBuyModal(trigger) {
    const card = trigger.closest('[data-product-card]');
    const dataNode = card?.querySelector('[data-quick-buy-data]');
    const modal = document.getElementById('QuickBuyModal');
    if (!dataNode || !modal) return;
    let product;
    try { product = JSON.parse(dataNode.textContent); } catch (_) { return; }

    quickBuyReturnFocus = trigger;
    modal.querySelector('[data-quick-buy-title]').textContent = product.title;
    modal.querySelector('[data-quick-buy-details]').href = product.url;
    const descriptor = modal.querySelector('[data-quick-buy-descriptor]');
    descriptor.textContent = product.descriptor || '';
    descriptor.hidden = !product.descriptor;
    const select = modal.querySelector('[data-quick-buy-variant]');
    select.replaceChildren();
    product.variants.forEach((variant) => {
      const option = document.createElement('option');
      option.value = String(variant.id);
      option.textContent = `${variant.title} — ${formatMoney(variant.price)}${variant.available ? '' : ' (Sold out)'}`;
      option.disabled = !variant.available;
      option.selected = Boolean(variant.selected && variant.available);
      option.dataset.variant = JSON.stringify(variant);
      select.append(option);
    });
    if (!select.selectedOptions[0] || select.selectedOptions[0].disabled) {
      const firstAvailable = Array.from(select.options).find((option) => !option.disabled);
      if (firstAvailable) firstAvailable.selected = true;
    }
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    lockBody();
    updateQuickBuyVariant(modal);
    setTimeout(() => select.focus(), 30);
  }

  function closeQuickBuyModal(restoreFocus = true) {
    const modal = document.getElementById('QuickBuyModal');
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    unlockBody();
    if (restoreFocus) quickBuyReturnFocus?.focus();
  }

  function toggleHidden(id, force) {
    const element = document.getElementById(id);
    if (!element) return false;
    const open = force === undefined ? element.hidden : force;
    element.hidden = !open;
    if (open) lockBody(); else unlockBody();
    return open;
  }

  document.addEventListener('click', async (event) => {
    const quickBuyOpen = event.target.closest('[data-quick-buy-open]');
    if (quickBuyOpen) {
      openQuickBuyModal(quickBuyOpen);
      return;
    }

    const quickBuyClose = event.target.closest('[data-quick-buy-close]');
    if (quickBuyClose) {
      closeQuickBuyModal();
      return;
    }

    const menuToggle = event.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      const open = toggleHidden('MobileMenu');
      document.querySelectorAll('[data-menu-toggle][aria-expanded]').forEach((button) => button.setAttribute('aria-expanded', String(open)));
      return;
    }

    const searchToggle = event.target.closest('[data-search-toggle]');
    if (searchToggle) {
      const open = toggleHidden('SearchOverlay');
      document.querySelectorAll('[data-search-toggle][aria-expanded]').forEach((button) => button.setAttribute('aria-expanded', String(open)));
      if (open) setTimeout(() => document.getElementById('HeaderSearch')?.focus(), 30);
      return;
    }

    const cartToggle = event.target.closest('[data-cart-toggle]');
    if (cartToggle) {
      const open = toggleHidden('CartDrawer');
      document.querySelectorAll('[data-cart-toggle][aria-expanded]').forEach((button) => button.setAttribute('aria-expanded', String(open)));
      return;
    }

    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const selector = quantityButton.closest('.quantity-selector');
      const input = selector?.querySelector('input[type="number"]');
      if (!input) return;
      const minimum = Number(input.min || 0);
      const minimumOrder = Number(input.dataset.minOrder || minimum);
      const maximum = input.max === '' ? Infinity : Number(input.max);
      const step = Number(input.step || 1);
      const direction = Number(quantityButton.dataset.quantityChange);
      let next = Number(input.value || 0) + direction * step;
      if (direction < 0 && minimum === 0 && next < minimumOrder) next = 0;
      input.value = Math.min(maximum, Math.max(minimum, next));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const removeButton = event.target.closest('[data-remove-line]');
    if (removeButton) {
      const line = removeButton.closest('[data-line]')?.dataset.line;
      if (line) await changeCart(line, 0);
      return;
    }

    const mediaButton = event.target.closest('[data-media-target]');
    if (mediaButton) {
      const gallery = mediaButton.closest('[data-product-gallery]');
      gallery?.querySelectorAll('[data-media-id]').forEach((media) => { media.hidden = media.dataset.mediaId !== mediaButton.dataset.mediaTarget; media.classList.toggle('is-active', !media.hidden); });
      gallery?.querySelectorAll('[data-media-target]').forEach((button) => button.classList.toggle('is-active', button === mediaButton));
      return;
    }

    const shareButton = event.target.closest('[data-share-button]');
    if (shareButton) {
      const data = { title: document.title, url: shareButton.dataset.shareUrl };
      if (navigator.share) await navigator.share(data); else { await navigator.clipboard.writeText(data.url); announce('Product link copied.'); }
      return;
    }

    const facetsToggle = event.target.closest('[data-facets-toggle]');
    if (facetsToggle) {
      document.querySelector('[data-facets-drawer]')?.classList.toggle('is-open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeQuickBuyModal();
    ['MobileMenu', 'SearchOverlay', 'CartDrawer'].forEach((id) => { const el = document.getElementById(id); if (el && !el.hidden) el.hidden = true; });
    document.querySelector('[data-facets-drawer]')?.classList.remove('is-open');
    unlockBody();
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-quick-buy-variant]')) updateQuickBuyVariant(event.target.closest('.quick-buy-modal'));
    if (event.target.matches('[data-localization-select]')) event.target.form?.submit();
    if (event.target.matches('[data-sort-select]')) event.target.form?.submit();
    if (event.target.closest('[data-variant-picker]')) updateVariant(event.target.closest('[data-product-root]'));
    if (event.target.closest('[data-cart-drawer] .quantity-selector input')) {
      const line = event.target.closest('[data-line]')?.dataset.line;
      if (line) changeCart(line, Number(event.target.value));
    }
  });

  document.addEventListener('submit', async (event) => {
    const productForm = event.target.closest('[data-product-form]');
    if (!productForm) return;
    event.preventDefault();
    const button = productForm.querySelector('[type="submit"]');
    const errors = productForm.querySelector('[data-product-errors]');
    button?.setAttribute('disabled', 'disabled');
    if (errors) errors.textContent = '';
    try {
      const response = await fetch(theme.cartAddUrl || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(productForm) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Could not add this item.');
      announce(`${result.product_title || 'Item'} added to cart.`);
      closeQuickBuyModal(false);
      if (theme.cartDrawerEnabled) { await refreshCartDrawer(true); } else { window.location.href = theme.cartUrl || '/cart'; }
    } catch (error) {
      if (errors) errors.textContent = error.message; else announce(error.message);
    } finally { button?.removeAttribute('disabled'); }
  });

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100); }
    catch (_) { return `$${(cents / 100).toFixed(2)}`; }
  }

  function updateVariant(root) {
    if (!root) return;
    const dropdown = root.querySelector('[data-variant-select]');
    let variant;
    if (dropdown) {
      const option = dropdown.selectedOptions[0];
      variant = { id: Number(option.value), price: Number(option.dataset.price), available: option.dataset.available === 'true' };
    } else {
      const data = root.querySelector('[data-product-variants]');
      if (!data) return;
      const values = Array.from(root.querySelectorAll('[data-option-position]:checked')).map((input) => input.value);
      variant = JSON.parse(data.textContent).find((item) => item.options.every((option, index) => option === values[index]));
    }
    const idInputs = root.querySelectorAll('[data-variant-id]');
    const button = root.querySelector('.product-form__submit');
    const label = root.querySelector('[data-add-label]');
    if (!variant) { if (button) button.disabled = true; if (label) label.textContent = 'Unavailable'; return; }
    idInputs.forEach((input) => { input.value = variant.id; });
    root.querySelectorAll('.product-form__submit, .mobile-buy-form button').forEach((submit) => { submit.disabled = !variant.available; });
    root.querySelectorAll('[data-add-label]').forEach((addLabel) => { addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out'; });
    const price = root.querySelector('.price__current');
    if (price && Number.isFinite(variant.price)) price.textContent = formatMoney(variant.price);
    applyVariantPurchaseRules(root, variant.id);
    const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
  }

  function applyVariantPurchaseRules(root, variantId) {
    const input = root.querySelector('[data-product-quantity]');
    const data = root.querySelector('[data-variant-quantity-rules]');
    if (input && data) {
      try {
        const rule = JSON.parse(data.textContent).find((item) => Number(item.id) === Number(variantId));
        if (rule) {
          const minimum = Number(rule.min || 1);
          const increment = Number(rule.increment || 1);
          input.min = String(minimum);
          input.step = String(increment);
          if (rule.max === null || rule.max === '') input.removeAttribute('max'); else input.max = String(rule.max);
          if (Number(input.value) < minimum || (Number(input.value) - minimum) % increment !== 0) input.value = String(minimum);
          const caption = root.querySelector('[data-quantity-rule-caption]');
          if (caption) {
            const parts = [];
            if (increment > 1) parts.push(`Multiples of ${increment}`);
            if (minimum > 1) parts.push(`Minimum ${minimum}`);
            if (rule.max !== null && rule.max !== '') parts.push(`Maximum ${rule.max}`);
            caption.textContent = parts.join(' · ');
          }
        }
      } catch (_) {}
    }
    root.querySelectorAll('[data-quantity-breaks-for]').forEach((panel) => { panel.hidden = Number(panel.dataset.quantityBreaksFor) !== Number(variantId); });
  }

  async function refreshCartDrawer(open) {
    const response = await fetch(`${window.location.pathname}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
    const sections = await response.json();
    const html = sections['cart-drawer'];
    if (!html) return;
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const replacement = documentFragment.querySelector('#CartDrawer');
    const current = document.getElementById('CartDrawer');
    if (replacement && current) current.replaceWith(replacement);
    const count = replacement?.querySelector('[data-cart-count]')?.textContent || '0';
    document.querySelectorAll('[data-cart-count]').forEach((element) => { element.textContent = count; });
    if (open) { toggleHidden('CartDrawer', true); document.querySelectorAll('[data-cart-toggle][aria-expanded]').forEach((button) => button.setAttribute('aria-expanded', 'true')); }
  }

  async function changeCart(line, quantity) {
    const errors = document.querySelector('[data-cart-errors]');
    if (errors) errors.textContent = '';
    try {
      const response = await fetch(theme.cartChangeUrl || '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Cart could not be updated.');
      await refreshCartDrawer(true);
    } catch (error) { if (errors) errors.textContent = error.message; announce(error.message); }
  }

  let searchTimer;
  document.addEventListener('input', (event) => {
    const priceSlider = event.target.closest('[data-price-slider]');
    if (priceSlider) {
      const minRange = priceSlider.querySelector('[data-price-min-range]');
      const maxRange = priceSlider.querySelector('[data-price-max-range]');
      const minNumber = priceSlider.querySelector('[data-price-min-number]');
      const maxNumber = priceSlider.querySelector('[data-price-max-number]');
      const output = priceSlider.querySelector('[data-price-output]');
      let min = Number(event.target === minNumber ? minNumber.value : minRange.value);
      let max = Number(event.target === maxNumber ? maxNumber.value : maxRange.value);
      if (min > max) { if (event.target === minRange || event.target === minNumber) min = max; else max = min; }
      minRange.value = String(min); maxRange.value = String(max); minNumber.value = String(min); maxNumber.value = String(max);
      if (output) output.textContent = `$${min} – $${max}`;
      const ceiling = Number(maxRange.max || 1);
      priceSlider.style.setProperty('--price-min', `${(min / ceiling) * 100}%`);
      priceSlider.style.setProperty('--price-max', `${(max / ceiling) * 100}%`);
      return;
    }
    const input = event.target.closest('[data-predictive-search] input[type="search"]');
    if (!input) return;
    clearTimeout(searchTimer);
    const results = input.closest('[data-predictive-search]').querySelector('[data-predictive-results]');
    if (input.value.trim().length < 2) { results.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
    searchTimer = setTimeout(async () => {
      try {
        const url = `${theme.predictiveSearchUrl || '/search/suggest'}?q=${encodeURIComponent(input.value)}&resources[type]=product,collection,page,article&resources[limit]=6&section_id=predictive-search`;
        const response = await fetch(url);
        results.innerHTML = await response.text();
        input.setAttribute('aria-expanded', 'true');
      } catch (_) { results.innerHTML = ''; }
    }, 220);
  });

  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    try {
      const response = await fetch(section.dataset.url);
      const html = await response.text();
      const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-product-recommendations]');
      if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
    } catch (_) {}
  });

  function initLoginDogs(scope = document) {
    scope.querySelectorAll('[data-login-dog]').forEach((dog) => {
      if (dog.dataset.initialized || !dog.classList.contains('login-dog--interactive')) return;
      dog.dataset.initialized = 'true';
      const art = dog.querySelector('.login-dog__art');
      const email = document.querySelector('[data-login-email]');
      const password = document.querySelector('[data-login-password]');
      const look = (x, y) => dog.querySelectorAll('.login-dog__eye i').forEach((pupil) => {
        pupil.style.setProperty('--look-x', `${Math.max(-5, Math.min(5, x))}px`);
        pupil.style.setProperty('--look-y', `${Math.max(-4, Math.min(4, y))}px`);
      });
      art?.addEventListener('pointermove', (event) => {
        const rect = art.getBoundingClientRect();
        look(((event.clientX - rect.left) / rect.width - .5) * 10, ((event.clientY - rect.top) / rect.height - .5) * 8);
      });
      art?.addEventListener('pointerleave', () => look(0, 0));
      email?.addEventListener('focus', () => { dog.classList.remove('is-shy'); look(-3, 3); });
      email?.addEventListener('input', () => look(-5 + Math.min(email.value.length, 20) / 2, 3));
      password?.addEventListener('focus', () => dog.classList.add('is-shy'));
      password?.addEventListener('blur', () => dog.classList.remove('is-shy'));
    });
  }

  initLoginDogs();
  function initProductGalleries(scope = document) {
    scope.querySelectorAll('[data-product-gallery-track]').forEach((track) => {
      if (track.dataset.swipeReady) return;
      track.dataset.swipeReady = 'true';
      const gallery = track.closest('[data-product-gallery]');
      const counter = gallery?.querySelector('[data-gallery-counter]');
      const slides = Array.from(track.querySelectorAll('[data-media-id]'));
      if (!counter || slides.length < 2) return;
      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const center = track.scrollLeft + track.clientWidth / 2;
          let nearest = 0;
          let distance = Infinity;
          slides.forEach((slide, index) => {
            const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
            const nextDistance = Math.abs(center - slideCenter);
            if (nextDistance < distance) { distance = nextDistance; nearest = index; }
          });
          counter.textContent = `${nearest + 1} / ${slides.length}`;
        });
      }, { passive: true });
    });
  }

  function initPriceSliders(scope = document) {
    scope.querySelectorAll('[data-price-slider]').forEach((slider) => {
      const min = Number(slider.querySelector('[data-price-min-range]')?.value || 0);
      const maxInput = slider.querySelector('[data-price-max-range]');
      const max = Number(maxInput?.value || 0);
      const ceiling = Number(maxInput?.max || 1);
      slider.style.setProperty('--price-min', `${(min / ceiling) * 100}%`);
      slider.style.setProperty('--price-max', `${(max / ceiling) * 100}%`);
    });
  }

  initProductGalleries();
  initPriceSliders();
  document.addEventListener('shopify:section:load', (event) => initLoginDogs(event.target));
  document.addEventListener('shopify:section:load', (event) => initProductGalleries(event.target));
  document.addEventListener('shopify:section:load', (event) => initPriceSliders(event.target));
})();
